import React from 'react'
import { MetricSeries, MessageConst } from 'enums'
import messageUtil from 'utils/messageUtil'

import PanelColumn from './PanelColumn'
import { resolveMetrics } from './utils'
import { NonNullableDataset } from './types'

interface TwitterPanelProps {
  data: NonNullableDataset
}

const TwitterPanel = ({ data }: TwitterPanelProps) => {
  const {
    engagements,
    reposts: retweets,
    replies,
    views,
    likes,
    impressions,
    netSentiment,
    positiveSentiment,
    negativeSentiment,
    passion
  } = resolveMetrics(data)

  return (
    <>
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.TOTAL_ENGAGEMENTS)}
        value={engagements}
      />
      {views !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.VIEWS)} value={views} />
      )}
      <PanelColumn title={messageUtil.measureType('TWRetweets')} value={retweets} />
      <PanelColumn title={messageUtil.measureType('TWReplies')} value={replies} />
      {/* firehose only */}
      {likes !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.LIKES)} value={likes} />
      )}
      <PanelColumn title={messageUtil.measureType(MetricSeries.IMPRESSIONS)} value={impressions} />
      {netSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NET_SENTIMENT)}
          value={`${netSentiment}%`}
        />
      )}
      {positiveSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.POSITIVE_SENTIMENT)}
          value={positiveSentiment}
        />
      )}
      {negativeSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NEGATIVE_SENTIMENT)}
          value={negativeSentiment}
        />
      )}
      {passion !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.PASSION)} value={passion} />
      )}
    </>
  )
}
export default TwitterPanel
